import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { SupportMessage } from "./AddTicket";
export type TicketDTO = {
  id: string;
  studentId: string;
  assignedToId: string;
  categoryId: boolean;
  subject: string;
  status: string;
  createdAt:string;
  updatedAt:string;
  assignedTo?: {
    firstName:string;
    lastName:string;
  };
  student:{
    email:string;
    lastName:string;
    firstName:string;
  };
  supportMessages: SupportMessage[];

};

interface TicketData {
  TicketData: TicketDTO[];
}
interface TicketResponse {
  data?: TicketData;
  error?: ApiError;
}

export const GetStudentTickets = async (): Promise<TicketResponse> => {
  try {
    const response = await axios.get("/support/myTickets");
    return { data: { TicketData: response.data } };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
